export default __webpack_public_path__ + "073994a4f8790ac39908f735cf52e339.svg";